<template>
  <div>
    <!-- 头像-->
    <div v-if="avatarFlag" class="Up_item">
      <viewer>
        <a-avatar shape="square"
                  :src="uploadFiles.length===0 || !regImg.test(uploadFiles[0].extension) ?defaultAvatar:uploadFiles[0].url"
                  :size="avatarSize" :style="'height:'+avatarHeight"/>
      </viewer>
    </div>
    <div v-else v-for="(file, idx) in uploadFiles" :key="file.id" class="Up_item">
      <div v-if="regImg.test(file.extension)">
        <viewer>
          <div class="img_box">
            <div class="img">
              <img :alt="file.url" style="width:200px;height: auto;display: block" :src="file.url"/>
            </div>
          </div>
        </viewer>
      </div>
      <div class="wj" v-else @click="downLoadMethod(idx)">
        <img :src="$_c + 'img/pdf.svg'">
        <span class="text1">{{ file.name }}</span>
        <span class="text2">{{ file.size }}</span>
        <span class="text3" @click="downLoadMethod(idx)">下载</span>
      </div>
    </div>
  </div>
</template>

<script>
const regImg = /(gif|jpg|jpeg|png|GIF|JPG|PNG)$/
export default {
  name: 'ExpertUploadView',
  props: {
    referId: {
      type: String,
      required: true,
      default: ''
    },
    configKey: {
      type: String,
      required: true
    },
    //默认头像
    defaultAvatar: {
      type: String,
      default: require('@/assets/head.jpg')
    },
    //是否是头像
    avatarFlag: {
      type: Boolean,
      default: false
    },
    avatarSize: {
      type: Number,
      default: 150
    },
    avatarHeight: {
      type: String,
      default: '210px'
    }
  },
  mounted () {
    this.refreshData()
  },
  watch: {
    referId (val) {
      this.refreshData()
    },
    configKey () {
      this.refreshData()
    }
  },
  data () {
    return {
      regImg,
      uploadFiles: [],
    }
  },
  methods: {
    downLoadMethod (idx) {
      let file = this.uploadFiles[idx]
      window.open(file.url)
    },
    refreshData () {
      const that = this
      if (!that.referId) {
        return
      }
      that.$http.get('/api/1/attachment/attachments.json?referId=' + that.referId + '&configKey=' + that.configKey).then(function (response) {
        if (response.code === 200) {
          let files = response.result.map(item => {
            let downloadUrl = null
            if (item.isExternal === 1) {
              downloadUrl = item.downloadUrl
            } else {
              downloadUrl = process.env.VUE_APP_WEB_SERVER + '/api/1/attachment/download?id=' + item.id
            }
            return {
              id: item.id,
              name: item.name,
              extension: item.extension,
              size: item.sizeDesc,
              percent: 100,
              response: null,
              clazz: 'ant-upload-list-item-done',
              url: downloadUrl,
              addDate: item.addDate,
              userName: item.extras && item.extras.userName,
            }
          })
          that.$emit('change',files.length)
          that.uploadFiles = files
        }
      })
    },

  }
}
</script>

<style lang="less" scoped>

.ant-upload.ant-upload-select-picture-card {
  float: none;
  width: 150px;
  height: 210px;
}

.Up_item {
  position: relative;
  display: inline-block;
  vertical-align: top;
  .img_box {
    position: relative;
    cursor: pointer;
    /deep/ .ant-avatar {
      border: 1px solid #e6e6e6;
    }
    &:after{
      content: "查看大图";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0,0,0,0.4);
      color: #fff;
      opacity: 0;
      transition: all .3s;
      pointer-events: none;
    }
    &:hover{
      &:after{
        opacity: 1;
      }
    }
  }

  .delete {
    width: 32px;
    height: 32px;
    background: #ff0000;
    color: #fff;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: -10px;
    top: -10px;
    cursor: pointer;
  }

  .wj{
    padding: 12px;
    border-radius: 4px;
    background: #f5f5f5;
    cursor: pointer;
    margin: 0 8px 8px 0;
    img{
      width: 20px;
      margin-right: 4px;
    }
    .text2{
      font-size: 12px;
      margin: 0 8px;
    }
    .text3{
      color: #1f76ff;
    }
    &:hover{
      background: #f1f1f1;
    }
  }
}
</style>
